import React from "react";

const IndexContext = React.createContext<ArrayBuffer | undefined>(undefined);
export { IndexContext };
